/**
 * 系统设置模块reducer
 */
import { combineReducers } from 'redux'
import * as ACTIONS from '../actions/setting_action'

function settingViewType(state = 'userManage', action) {
    switch (action.type) {
        case ACTIONS.SET_SETTINGVIEWTYPE:
            return action.settingViewType
        default:
            return state
    }
}

function submenuSettingViewType(state = 'userManage', action) {
    switch (action.type) {
        case ACTIONS.SET_SUBMENUSETTINGVIEWTYPE:
            return action.submenuSettingViewType
        default:
            return state
    }
}

function userInfo(state = null, action) {
    switch (action.type) {
        case ACTIONS.SET_USERINFO:
            return action.userInfo
        default:
            return state
    }
}

function userList(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_USERLIST:
            return action.userList
        default:
            return state
    }
}

function organizationData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_ORGANIZATIONDATA:
            return action.organizationData
        default:
            return state
    }
}

function organizationRoleData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_ORGANIZATIONROLEDATA:
            return action.organizationRoleData
        default:
            return state
    }
}

function areaData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_AREADATA:
            return action.areaData
        default:
            return state
    }
}

function unitData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_UNITDATA:
            return action.unitData
        default:
            return state
    }
}

function departmentData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_DEPARTMENTDATA:
            return action.departmentData
        default:
            return state
    }
}

function departmentJobData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_DEPARTMENTJOBDATA:
            return action.departmentJobData
        default:
            return state
    }
}

function roleList(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_ROLELIST:
            return action.roleList
        default:
            return state
    }
}

function permissionData(state = null, action) {
    switch (action.type) {
        case ACTIONS.SET_PERMISSIONDATA:
            return action.permissionData
        default:
            return state
    }
}

function rolePermission(state = null, action) {
    switch (action.type) {
        case ACTIONS.SET_ROLEPERMISSION:
            return action.rolePermission
        default:
            return state
    }
}

function groupList(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_GROUPLIST:
            return action.groupList
        default:
            return state
    }
}

function eccGroupData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_ECCGROUPDATA:
            return action.eccGroupData
        default:
            return state
    }
}

function DBConnectionList(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_DBCONNECTIONLIST:
            return action.DBConnectionList
        default:
            return state
    }
}

function DBConnectionInfo(state = null, action) {
    switch (action.type) {
        case ACTIONS.SET_DBCONNECTIONINFO:
            return action.DBConnectionInfo
        default:
            return state
    }
}

function backgroundInfo(state = null, action) {
    switch (action.type) {
        case ACTIONS.SET_BACKGROUNDINFO:
            return action.backgroundInfo
        default:
            return state
    }
}

function backgroundServices(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_BACKGROUNDSERVICES:
            return action.backgroundServices
        default:
            return state
    }
}

function selfCheckData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_SELFCHECKDATA:
            return action.selfCheckData
        default:
            return state
    }
}

function licenseData(state = null, action) {
    switch (action.type) {
        case ACTIONS.SET_LICENSE_DATA:
            return action.licenseData
        default:
            return state
    }
}

function imageResourceData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_IMAGERESOURCE_DATA:
            return action.imageResourceData
        default:
            return state
    }
}

function dbDefaultBackDbUrl(state = "", action) {
    switch (action.type) {
        case ACTIONS.SET_DBDEFAULTBACKDBURL:
            return action.dbDefaultBackDbUrl
        default:
            return state
    }
}

function schedulerData(state = [], action) {
    switch (action.type) {
        case ACTIONS.SET_SCHEDULER_DATA:
            return action.schedulerData
        default:
            return state
    }
}

function selfCheckDataStatusNum(state = {goodNum:0, warningNum:0, errorNum:0}, action) {
    switch (action.type) {
        case ACTIONS.SET_SELFCHECKDATA_STATUSNUM:
            return action.selfCheckDataStatusNum
        default:
            return state
    }
}

const settingReducer = combineReducers({
    settingViewType,
    submenuSettingViewType,
    userInfo,
    userList,
    organizationData,
    organizationRoleData,
    areaData,
    unitData,
    departmentData,
    departmentJobData,
    roleList,
    permissionData,
    rolePermission,
    groupList,
    eccGroupData,
    DBConnectionList,
    DBConnectionInfo,
    backgroundInfo,
    backgroundServices,
    selfCheckData,
    licenseData,
    imageResourceData,
    dbDefaultBackDbUrl,
    schedulerData,
    selfCheckDataStatusNum,
})

export default settingReducer
